/** 提供商配置页的 hash 路由路径（T15）：独立于底部导航的四条主路由。 */
export const PROVIDERS_PATH = '/providers';